import React, { useState, useCallback, useEffect } from 'react';
import { Section, Container } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import { Dropdown } from 'components/components/atoms';
import { useCountryValue, switchCountry } from 'stores/country';
import LeftArrowIcon from 'components/icons/LeftArrow';
import tw from 'twin.macro';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import cx from 'classnames';

const StyledHeading = styled.h2`
  letter-spacing: -0.01em;
`;
const DropdownContainer = styled.div`
  ${({ isMobile }) => (isMobile ? 'width: 100%;' : 'width: 10rem;')}
`;

const Grid = styled.div`
  ${({ isMobile }) => (isMobile ? 'padding-right: 0; padding-left: 0;' : '')}
`;
const LeftIconArea = styled.div`
  display: flex;
  opacity: 0;
  align-items: center;
  right: 0;
  bottom: 0rem;
  top: 0;
  transition: all 0.3s ease-out;
`;
const Area = styled.button`
  ${tw`flex leading-6 hover:text-mattamy-blue py-1 tracking-normal font-light relative`}
  &:hover {
    font-weight: bold;
  }
  &:hover ${LeftIconArea} {
    opacity: 1;
    right: -1.5rem;
  }
`;

const ContactMarketCardsPanel = ({
  fields,
  handleMarketCardClick,
  selectedMarket,
}) => {
  // const [expandedItem, setExpandedItem] = useState(null);
  const [indexdSelectedItem, setIndexdSelectedItem] = useState(0);
  /* const handleItemExpandedClick = (row, index) => {
    const itemId = `${row}-${index}`;
    setExpandedItem(itemId === expandedItem ? null : itemId);
    setIndexdSelectedItem("-1");
  };*/
  const marketCards = getFieldValue(fields, 'marketCards') || [];
  const marketsDropdown = getFieldValue(fields, 'marketsDropdown');

  const location = useLocation();
  const params = queryString.parse(location.search) || {};
  const navigate = useNavigate();

  const filterParam = params.filter;

  const [activeFilter, setActiveFilter] = useState(filterParam || 'market');

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  const [{ country }, dispatch] = useCountryValue();

  const toggleCountry = useCallback(() => {
    dispatch(switchCountry());
    if (typeof window !== 'undefined' && localStorage) {
      var uc = country === 'USA' ? 'CAN' : 'USA';
      localStorage.setItem('userCountry', uc);
    }
    const newParams = { country: uc };
    navigate({
      pathname: location.pathname,
      search: '?' + new URLSearchParams(newParams).toString(),
      hash: location.hash,
    });
    handleMarketCardClick();
  }, [country]);

  const [active, setActive] = useState(false);
  // const [selectedMarket, setSelectedMarket] = useState();

  let columns = 2;
  if (breakpoint === 'md') {
    columns = 3;
  } else if (['lg', 'xl', '2xl'].includes(breakpoint)) {
    columns = 4;
  }

  const filteredMarketsCards = marketCards
    .filter((marketCard) => marketCard.country === country)
    .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));

  const marketsCopy = [...filteredMarketsCards];
  const marketRows = [];
  while (marketsCopy.length) {
    marketRows.push(marketsCopy.splice(0, columns));
  }
  const getStateFromMarket = (label) => {
    if (label) {
      const textArray = label.split(',');
      const textArrayLen = textArray.length;
      if (textArrayLen > 0) return textArray[textArrayLen - 1];
    }
    return label;
  };
  return (
    <Section noPaddingMobile>
      <Container
        noPadding
        className='flex flex-col items-start w-full mb-4 md:mb-8'
      >
        {marketsDropdown && (
          <>
            <div
              // isMobile={isMobile}
              className='flex w-full justify-between md:justify-start px-5 md:px-0 md:w-1/2 mb-5 mt-2 md:my-4'
            >
              <DropdownContainer className='md:mr-10' isMobile={isMobile}>
                <Dropdown
                  dropdownDescription={
                    country === 'USA'
                      ? 'Country selector, USA is selected'
                      : 'Country selector, Canada is selected'
                  }
                  label={country === 'USA' ? 'USA' : 'Canada'}
                  active={active}
                  activeFilter={activeFilter === 'market'}
                  setActive={setActive}
                  outlined
                >
                  <button
                    className='lg:flex justify-center items-center w-full md:w-32 md:py-1 text-sm cursor-pointer'
                    onClick={() => {
                      toggleCountry();
                      setActive(false);
                      // setSelectedMarket();
                      handleMarketCardClick();
                    }}
                  >
                    <span>{country === 'USA' ? 'Canada' : 'USA'}</span>
                  </button>
                </Dropdown>
              </DropdownContainer>
            </div>
          </>
        )}

        <div className='w-full p-8 bg-light-blue md:rounded'>
          <StyledHeading
            className='mt-0 md:mt-4 text-2xl md:text-3xl text-mattamy-blue font-trade-gothic-20  mb-3 md:mb-2'
            onFocus={(e) => {
              setIndexdSelectedItem('0');
            }}
          >
            {' Please Select Your Area'}
          </StyledHeading>

          {marketRows.map((row, rowIndex) => {
            return (
              <Grid
                key={rowIndex}
                className='z-0 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 md:gap-x-2 mt-4 md:mt-6 md:mt-0 select-none w-full overflow-hidden'
                isMobile={isMobile}
              >
                {row.map((market, index) => {
                  const expanded = market.name === selectedMarket;
                  return (
                    <div
                      key={market.name}
                      className='justify-start inline-grid'
                      onFocus={(e) => {
                        setIndexdSelectedItem('0');
                      }}
                    >
                      <Area
                        tabIndex={indexdSelectedItem}
                        onClick={() => {
                          handleMarketCardClick(market.name, !expanded);
                          // setSelectedMarket(market.name);
                          // handleItemExpandedClick(market.name, index);
                        }}
                        aria-expanded={expanded}
                        className={cx(
                          'relative text-md md:text-xl text-contact-blue-color font-trade-gothic-20 mb-0 md:mb-3 cursor-pointer uppercase',
                          {
                            'font-bold text-mattamy-blue underline':
                              market.name === selectedMarket,
                          },
                        )}
                        aria-label={
                          'View contact details of ' +
                          market.name +
                          ', ' +
                          getStateFromMarket(market.state) +
                          ' ' +
                          'State'
                        }
                      >
                        {market.name + ', ' + getStateFromMarket(market.state)}
                        <LeftIconArea className={'absolute mb-2'}>
                          <LeftArrowIcon
                            className={
                              'transform text-mattamy-blue w-3 h-3 rotate-180'
                            }
                            id={'Area-' + market.name}
                          />
                        </LeftIconArea>
                      </Area>
                    </div>
                  );
                })}
              </Grid>
            );
          })}
        </div>
      </Container>
    </Section>
  );
};

export default ContactMarketCardsPanel;
